<div class="row m-0 justify-content-center" style="padding-top: 25px;" *ngIf="isCheckIn && data">
  <div class="col-12 container-items p-0 m-0">
    <div class="d-flex container-item-card justify-content-between" style="border: 2px solid #c2c2c3; border-radius: 8px; gap: 25px">
      <div class="flex-xl-grow-0 flex-grow-1 w-100" style="width: 100%; max-width: 175px">
        <img
          style="
            width: 100%;
            height: 100%;
            cursor: pointer;
            object-fit: contain;
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          "
          width="100"
          height="100"
          [src]="imgTransfer"
        />
      </div>

      <div class="hotel-item-description px-0" style="width: calc(100% - 190px)">
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-between align-items-start">
            <!-- Title -->
            <div class="d-flex flex-column pt-2">
              <p
                class="tittle"
                style="font-family: &quot;Poppins&quot;; font-size: 20px; font-weight: 400; line-height: 1.3; margin-top: 5px !important;
                margin-bottom: 0px !important;"
              >
                {{ data?.title || "Falta el nombre" }}
              </p>
              <p
                class="mb-0"
                style="
                  font-family: &quot;Poppins&quot;;
                  font-size: 13.48px !important;
                  font-weight: 500;
                  font-style: italic;
                  line-height: 1.3;
                "
              >
                {{ data?.transferType }}
              </p>
            </div>

            <div class="d-flex">
              <!-- STATUS -->
              <div class="pr-3" style="padding-top: 13px;">
                <span *ngIf="data.status_id === 1" class="status status-sidebar product-status-saved">{{ data.status }}</span>
                <span *ngIf="data.status_id === 2" class="status status-sidebar product-status-reserved">{{ data.status }}</span>
                <span *ngIf="data.status_id === 3" class="status status-sidebar product-status-locked">{{ data.status }}</span>
                <span *ngIf="data.status_id === 4" class="status status-sidebar product-status-denied">{{ data.status }}</span>
                <span *ngIf="data.status_id === 5" class="status status-sidebar product-status-cancelled">{{ data.status }}</span>
                <span *ngIf="data.status_id === 6" class="status status-sidebar product-status-paid-agency">{{ data.status }}</span>
                <span *ngIf="data.status_id === 7" class="status status-sidebar product-status-paid-provider">{{ data.status }}</span>
                <span *ngIf="data.status_id === 8" class="status status-sidebar product-status-completed">{{ data.status }}</span>
              </div>

              <div
                *ngIf="data.status_id !== 5"
                class="d-flex pr-3 pl-3 pb-2 pt-2"
                style="border-bottom: 2px solid #ccc; border-left: 1px solid #ccc; border-bottom-left-radius: 6px; gap: 5px"
              >
                <div *ngIf="permissions['booking.itinerarios.editarproducto'] && data.status_id === 1" style="width: 25px; height: 25px">
                  <img
                    style="margin-top: -5px; cursor: pointer"
                    tooltip="Editar producto"
                    placement="bottom"
                    (click)="edit(data)"
                    src="../../../../assets/icons/summary/edit.svg"
                    alt=""
                  />
                </div>
                <div style="width: 25px; height: 25px" *ngIf="data.status_id === 1">
                  <img
                    style="margin-top: -4px; cursor: pointer"
                    tooltip="Eliminar producto"
                    (click)="removeItem(data)"
                    placement="bottom"
                    src="../../../../assets/icons/summary/delete.svg"
                    alt=""
                  />
                </div>
                <div style="width: 25px; height: 25px" *ngIf="data.status_id === 2">
                  <img
                    style="
                      margin-top: -4px;
                      cursor: pointer;
                      filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                    "
                    tooltip="Cancelar producto"
                    (click)="removeItem(data)"
                    placement="bottom"
                    src="../../../../assets/icons/itinerary-detail/04-01.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-stretch" style="margin-top: 15px; margin-bottom: 15px">

          <!-- Location -->
          <div class="d-flex flex-column justify-content-center pt-3" [ngStyle]="{ 'width': isTransferOut ? '55%' : '47%' }" style="min-height: 62px;">
            <div class="d-flex align-items-start" style="width: 100%">
              <div>
                <img width="20px" height="20px" style="margin-top: -5px" src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
              </div>

              <div class="d-flex flex-column">
                <div class="d-flex">
                  <div class="d-flex flex-row" style="gap: 0.25em">
                    <p
                      class="mb-0"
                      style="
                        font-family: &quot;Poppins&quot;, serif !important;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 1.2;
                        min-width: 58px;
                      "
                    >
                      PICK UP
                    </p>
                    <p
                      class="mb-0 truncate-2-lines"
                      style="
                        font-family: &quot;Rubik&quot;, serif !important;
                        font-size: 13.01px;
                        font-weight: 600;
                        line-height: 1.2;
                        text-transform: capitalize;
                      "
                      [tooltip]="extractNameTransport(data, 'origin')"
                      placement="bottom"
                    >
                      {{ extractNameTransport(data, "origin") }}
                    </p>
                  </div>
                </div>

                <div class="d-flex">
                  <!-- <img width="25px" height="28px" style="margin-top: -5px" src="../../../../assets/icons/itinerary/lugar.svg" alt=""> -->
                  <div class="d-flex flex-row" style="gap: 0.25em">
                    <p
                      class="mb-0"
                      style="
                        font-family: &quot;Poppins&quot;, serif !important;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 1.2;
                        min-width: 58px;
                      "
                    >
                      DROP OFF
                    </p>
                    <p
                      class="mb-0 truncate-2-lines"
                      style="
                        font-family: &quot;Rubik&quot;, serif !important;
                        font-size: 13.01px;
                        font-weight: 600;
                        line-height: 1.2;
                        text-transform: capitalize;
                      "
                      [tooltip]="extractNameTransport(data, 'destination')"
                      placement="bottom"
                    >
                      {{ extractNameTransport(data, "destination") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex font-inline flex-row">
              <span
                class="check mb-0"
                [ngStyle]="{ 'color': isTransferOut ? '#fe2e54' : '' }"
              >
                {{ isTransferOut ? "Transfer-out" : "Transfer-in" }}
              </span>
            </div>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <!-- Pax -->
          <div class="d-flex justify-content-center px-3 pt-3" [ngStyle]="{ 'width': isTransferOut ? '59%' : '29%' }">
            <div class="d-flex flex-column">
              <p
                class="p-0 m-0 inter"
                style="font-family: &quot;Rubik&quot;, serif !important; font-size: 13px; font-weight: 600; line-height: 1.3"
              >
                {{ data.vehicle.number_of_seats ? data.vehicle.number_of_seats : "0" }} Asientos |&nbsp;{{
                  data.vehicle.bag.maxBag
                }}
                Valijas
              </p>
              <p
                class="p-0 m-0 inter"
                style="font-family: &quot;Rubik&quot;, serif !important; font-size: 13px; font-weight: 600; line-height: 1.3"
              >
                Diurno
              </p>
            </div>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <!-- Price -->
          <div *ngIf="!isTransferOut" class="d-flex flex-column pr-3" style="width: 29%; align-items: flex-end; min-height: 62px; margin-top: -6px;">
            <p
              class="title-destiny-start text-nowrap mb-0"
              [ngClass]="{ 'pr-3': data.status_id !== 5 }"
              style="
                font-family: &quot;Rubik&quot;, serif !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                line-height: 1.3;
                color: #666666;
              "
            >
              {{ currencyAgency.code }}
            </p>
            <div class="d-flex align-items-center">
              <p
                class="title-destiny-start text-nowrap mb-0"
                style="color: #000000; font-family: &quot;Rubik&quot;, serif !important; font-weight: 600 !important; line-height: 1.3"
                [ngStyle]="{ 'font-size': getPrice(data) | dynamicFontSize: 20 : fontSizeAdjustments }"
              >
                <span *ngIf="data.status_id !== 5">
                  {{ getPrice(data) | number: "1.2-2" }}
                </span>
                <span *ngIf="data.status_id === 5">
                  {{ 0 | number: "1.2-2" }}
                </span>
              </p>
              <ng-container *ngIf="data.status_id !== 5">
                <usb-tooltip-convert-amount
                  [clientsSettingAppBooking]="clientSetting"
                  [currencyProduct]="data.currency"
                  [valueProduct]="data.totalPriceProf"
                >
                </usb-tooltip-convert-amount>
              </ng-container>
            </div>
            <div *ngIf="data.status_id !== 5" class="d-flex flex-column justify-content-end align-items-center">
              <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif !important; font-size: 12px; line-height: 1.3">imp. incl.</p>
              <div *ngIf="data.currency !== currencyAgency?.code" class="d-flex justify-content-end align-items-center">
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">
                  {{ data.currency }} {{ data.totalPriceProf | number: "1.2-2" }}
                </p>
                <div class="info-tool d-flex flex-column position-relative">
                  <img src="../../../assets/icons/admi_01.svg" width="12px" alt="" />
                  <span class="tooltip-info shadow-md">
                    <div class="d-flex justify-content-center align-items-center px-2 py-1">
                      <p class="mb-0" style="font-size: 14px; color: black">{{ userService.messageProviderAmount }}</p>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
